module.exports = __webpack_public_path__ + "static/media/login-bg.e1029116.png";